import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserStampsRedemptionHistory } from '@/shared/model/user-stamps-redemption-history.model';

const baseApiUrl = 'api/user-stamps-redemption-histories';
const baseSearchApiUrl = 'api/_search/user-stamps-redemption-histories?query=';

export default class UserStampsRedemptionHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserStampsRedemptionHistory> {
    return new Promise<IUserStampsRedemptionHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserStampsRedemptionHistory): Promise<IUserStampsRedemptionHistory> {
    return new Promise<IUserStampsRedemptionHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserStampsRedemptionHistory): Promise<IUserStampsRedemptionHistory> {
    return new Promise<IUserStampsRedemptionHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
